export default "__VITE_ASSET__BPe1ELyh__"